interface GetPdfThumbnailUrlOptions {
  scale: number;
  width: number;
  height: number;
  refresh: boolean;
}

export default function getPdfThumbnailUrl(
  url: string,
  page = 1,
  options: Partial<GetPdfThumbnailUrlOptions> = {}
) {
  const { scale, width, height, refresh = false } = options;
  const { FILESERVICE: FILESERVICE_URL } = window.Glide;

  if (!FILESERVICE_URL) {
    throw new Error('FILESERVICE constant is not defined.');
  }

  if ([scale, width, height].filter((val) => val !== undefined).length !== 1) {
    throw new Error(
      'One of the size options need to be set: scale, width, height'
    );
  }

  let sizeParam = '';
  if (scale) {
    sizeParam = `&scale=${scale}`;
  } else if (width) {
    sizeParam = `&width=${width}`;
  } else if (height) {
    sizeParam = `&height=${height}`;
  }

  if (!page || page < 1) {
    throw new Error('Page has to be');
  }

  return `${FILESERVICE_URL}/thumbnail?url=${encodeURIComponent(
    url
  )}&page=${page}${sizeParam}${refresh ? '&refresh=true' : ''}`;
}
